function RightBlogContent({ data, Link }) {
  return (
    <>
      <div style={{ position: "sticky", top: "1px" }}>
        <aside className="post-sidebar web">
          <h4 className="sidebar-title">Related Posts</h4>
          <ul className="related-list">
            {data?.related?.map((post, index) => (
              <li key={index}>
                <Link to={`/blog/${post?.action_url}`}>
                  <div className="finder_track">
                    <div>
                      <img src={post?.media} alt="Related 1" className="pointer-crusser" />
                    </div>

                    <div className="pointer-crusser">
                      <p>{post?.name}</p>
                      <span>
                        {post?.description?.split(" ").slice(0, 15).join(" ")}
                        {post?.description?.split(" ").length > 15 ? "..." : ""}
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </>
  )
}
export default RightBlogContent;